export default from './reducers'

export { default as Page } from './components/Page'
export { KB_PAGE } from './pages'
export { default as routes } from './routes'
export { selectIsOnArticlesPage } from './selectors'
